import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";
import { blogArticleSlug } from "@/mocks/blogContent";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20fashion%20collage%20with%20soft%20organic%20shapes%20and%20geometric%20patterns%20in%20warm%20cream%20beige%20terracotta%20sand%20tones%20featuring%20scattered%20minimalist%20product%20silhouettes%20of%20clothing%20shoes%20and%20accessories%20floating%20in%20airy%20negative%20space%20soft%20gradient%20background%20dreamy%20editorial%20aesthetic&width=1600&height=900&seq=mulebuy-hero-bg-2026x2&orientation=landscape"
          alt="Mulebuy Spreadsheet product database collage"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 pt-24 pb-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 lg:gap-16">
          {/* Left Content */}
          <div className="lg:w-3/5">
            {/* Social Proof */}
            <div className="flex items-center gap-3 mb-8">
              <div className="flex -space-x-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20single%20cream%20beige%20canvas%20sneaker%20on%20light%20neutral%20surface%20soft%20studio%20lighting%20clean%20simple%20composition%20editorial%20quality%20warm%20earth%20tones&width=60&height=60&seq=mulebuy-avatar-f1-x2&orientation=squarish"
                    alt="User avatar"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20soft%20sage%20green%20cotton%20hoodie%20folded%20on%20light%20neutral%20surface%20soft%20studio%20lighting%20clean%20simple%20composition%20editorial%20quality%20warm%20organic%20tones&width=60&height=60&seq=mulebuy-avatar-f2-x2&orientation=squarish"
                    alt="User avatar"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20woven%20straw%20panama%20hat%20on%20light%20neutral%20surface%20soft%20studio%20lighting%20clean%20simple%20composition%20editorial%20quality%20warm%20natural%20tones&width=60&height=60&seq=mulebuy-avatar-f3-x2&orientation=squarish"
                    alt="User avatar"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-white/90 text-sm md:text-base font-medium">
                Trusted by 10,000+ Shoppers
              </span>
            </div>

            {/* Main Title */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-6">
              <span className="block">Mulebuy Spreadsheet</span>
              <span className="block font-light text-2xl md:text-4xl lg:text-5xl mt-2 text-white/90">
                The Most Updated Product
                <br />
                Spreadsheet Database
              </span>
            </h1>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-white text-foreground-950 font-medium text-sm md:text-base hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
              >
                Explore Latest Spreadsheet
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-foreground-950">
                  <i className="ri-arrow-right-line text-white text-xs"></i>
                </span>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-white/15 text-white border border-white/30 font-medium text-sm md:text-base hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-white/20">
                  <i className="ri-arrow-right-line text-white text-xs"></i>
                </span>
              </a>
              <Link
                to={`/blog/${blogArticleSlug}`}
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-accent-500 text-white font-medium text-sm md:text-base hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Read Full Guide
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-black/20">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            </div>
          </div>

          {/* Right Description */}
          <div className="lg:w-2/5 lg:pb-6">
            <p className="text-white/85 text-sm md:text-base leading-relaxed max-w-sm lg:ml-auto">
              Discover trending products, verified listings, and curated mulebuy spreadsheet
              collections designed to help you save money and find high-quality items faster
              across 14 product categories — updated weekly for accuracy and relevance.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}